import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { RootState } from "@/store";
import { queryRequest } from "@/utils/request";
import {
  getCustomOrderDetailAndPhone,
  cancelOrder,
  wtCreateReturn,
  getRefundReason,
  dealWithReceived
} from "@/graphql/order.gql";
import { queryDataDictionaryListLang } from "@/graphql/dictionary.gql";
import { formatProductData } from "@/utils/mall/mall";

export interface MallOrderDetailState {
  orderDetail: any;
  userCancelReasons: any[];
  systemCancelReasons: any[];
}

@Module({ name: "MallOrderDetailModule", namespaced: true })
export default class MallOrderDetailModule
  extends VuexModule<MallOrderDetailState, RootState>
  implements MallOrderDetailState {
  public orderDetail = {};

  public userCancelReasons = [];
  public systemCancelReasons = [];

  @Mutation
  saveOrderDetailMutation(data: any) {
    this.orderDetail = data ?? {};
  }
  @Mutation
  saveUserCancelReasonsMutation(data: any[]) {
    this.userCancelReasons = data ?? [];
  }
  @Mutation
  saveSystemCancelReasonsMutation(data: any[]) {
    this.systemCancelReasons = data ?? [];
  }

  // 获取订单详情
  @Action
  async initDataAction() {
    const {
      state: { orderDetail }
    } = this.context;
    const { orderDetail: data, servicePhone, telPhone } = await queryRequest(
      {
        query: getCustomOrderDetailAndPhone,
        variables: {
          orderCommonInput: {
            orderCode: orderDetail.orderCode
          }
        }
      },
      { custom: true }
    );
    data.orderProductOutList = data.orderProductOutList.map(sku => {
      sku.productName = sku.skuName;
      return formatProductData(sku);
    });
    this.context.commit("saveOrderDetailMutation", data);
  }

  // 取消订单 -- 待支付
  @Action
  async cancelOrderAction(order) {
    const { result } = await queryRequest({
      query: cancelOrder,
      variables: {
        orderCancelInput: {
          orderCode: order.orderCode
        }
      }
    });
    return result;
  }

  // 取消订单 -- 待发货
  @Action
  async wtCreateReturnAction(order) {
    const { success } = await queryRequest({
      query: wtCreateReturn,
      variables: {
        orderCode: order.orderCode
      }
    });
    return success;
  }

  // 查询用户取消原因
  @Action
  async queryUserCancelReasonAction() {
    const data = await queryRequest({
      query: queryDataDictionaryListLang,
      variables: {
        input: {
          ddCode: "CANCEL_REASON_TYPE",
          lang: window.i18n.locale
        }
      }
    });
    this.context.commit("saveUserCancelReasonsMutation", data);
  }

  // 查询系统取消原因
  @Action
  async querySystemCancelReasonAction() {
    const data = await queryRequest({
      query: queryDataDictionaryListLang,
      variables: {
        input: {
          ddCode: "RETURN_REASON_TYPE",
          lang: window.i18n.locale
        }
      }
    });
    this.context.commit("saveSystemCancelReasonsMutation", data);
  }

  // 查询退款原因
  @Action
  async queryOrderCancelReasonAction() {
    const {
      state: { orderDetail }
    } = this.context;
    const refundCode = orderDetail.orderReturnOuts[0]?.returnCode;
    if (refundCode) {
      const data = await queryRequest({
        query: getRefundReason,
        variables: { refundCode }
      });
      this.context.commit("saveOrderDetailMutation", {
        ...orderDetail,
        _cancelReason: data?.code || "顾客不想要"
      });
    }
  }

  // 确认收货
  @Action
  async dealWithReceivedAction(variables: any) {
    return await queryRequest({
      query: dealWithReceived,
      variables
    });
  }
}
